import type { ReactNode } from "react";
import "./codePalette.css";
import type { HighlightedToken } from "./HighlightedCode";

/**
 * A line's tokens: tokens with palette classes as spans, text in the default color as plain text,
 * joined with the line break so React adds no text separators between them.
 */
export const renderTokens = (line: HighlightedToken[], end = ""): ReactNode[] => {
  const children: ReactNode[] = [];
  let text = "";
  for (const [index, token] of line.entries()) {
    if (!token.className) {
      text += token.content;
      continue;
    }
    if (text) children.push(text);
    text = "";
    children.push(
      // Tokens are positional and never reordered.
      <span key={index} className={token.className}>
        {token.content}
      </span>,
    );
  }
  if (text || end) children.push(text + end);
  return children;
};
